export default import.meta.ROLLUP_FILE_URL_5ueHAtn9JtiQ3lCiqsnAfg;